export default __webpack_public_path__ + "static/media/sicredi-branco-logo.42631227.svg";